import Generic from "../components/Generic";
import Components from "../components/Components";

export const navbar = [
  { id: 1, title: "Docs", path: "/docs", element: <Generic /> },
  { id: 2, title: "Components", path: "/components", element: <Components /> },
  { id: 3, title: "Resources", path: "/resources", element: <Generic /> },
];
